module.exports = __webpack_public_path__ + "common/images/item-selected-bg.jpg";


//////////////////
// WEBPACK FOOTER
// ./common/images/item-selected-bg.jpg
// module id = 29
// module chunks = 0 1 2 3 4 5 6 7